import type { ChatMediaInfoPartial } from './types';
import {
  CallTokenStatus,
  ChatMediaType,
  type ChatMedia,
  type ChatMediaInfo,
} from './types';

export function genChatMediaInfo(
  args: ChatMediaInfoPartial,
  newargs: ChatMediaInfoPartial
): ChatMediaInfo {
  return {
    type: ChatMediaType.SINGLE,
    is_busy: CallTokenStatus.IDLE,
    rtc_token: '',
    room_id: '',
    message_id: '',
    cli_msg_id: '',
    code: '',
    payload_type: 0,
    status: 0,
    owner_id: '',
    caller: null,
    callMembers: [],
    ...args,
    ...newargs,
    chat: {
      ...args?.chat,
      ...newargs?.chat,
    } as never,
  };
}

export function genChatMedia(): ChatMedia {
  return {
    openMediaModal: false,
    openMediaNotice: false,
    mediaModalZoomIn: false,
    activatedId: undefined,
    chatMediaInfoMap: {},
  };
}
